import { Link } from 'gatsby-plugin-react-intl'

import styled from 'styled-components'

const Button = styled(Link)`
  display: inline-block;
  line-height: 48px;

  min-height: 48px;
  padding: 0 32px;
  border-radius: 4px;
  text-decoration: none;
  color: #fff;
  font-size: 12.6px;
  letter-spacing: 0.8px;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
  white-space: nowrap;
  border: none;
  transition: all 0.2s;
`

export const ButtonContact = styled(Button)`
  background-color: var(--orange);
  :hover {
    background-color: #f2420c;
  }

  @media (max-width: 767px) {
    min-width: 100%;
  }
`

export const ButtonDefault = styled(Button)`
  background-color: var(--orange);

  :hover {
    background-color: #f2420c;
  }
`

export const WhiteButton = styled(Button)`
  border: 2px solid var(--orange);
  background-color: #fff;
  color: var(--orange);

  :hover {
    border: 2px solid #fff;
    background-color: var(--orange);
    color: #fff;
  }
`

export const OutlineWhiteButton = styled(Button)`
  border: 2px solid #ffffff;
  background-color: var(--orange);
  color: #ffffff;

  :hover {
    border: 2px solid var(--orange);
    background-color: #ffffff;
    color: var(--orange);
  }
`

export const OutlineColorButton = styled(Button)`
  border: 1px solid ${({ borderColor }) => borderColor};
  background-color: transparent;
  color: ${({ colorText }) => colorText};

  :hover {
    border: 1px solid var(--orange);
    background-color: #ffffff;
    color: ${({ colorText }) => colorText};
  }
`

export const ButtonOutline = styled(Button)`
  background-color: transparent;
  color: var(--orange);
  border: 2px solid var(--orange);

  :hover {
    background-color: var(--orange);
    color: #fff;
  }

  @media (max-width: 767px) {
    display: block;
    width: 100%;
  }
`

export const TestFreeCtaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

export const LabelLink = styled.button`
  display: inline-block;
  font-size: 16px;
  line-height: 28px;
  color: var(--orange);
  text-decoration: none;
  transition: all 0.2s;
  padding: 4px 0;
  margin-top: 20px;
  border: 0;
  appearance: none;
  border-bottom: 1px solid #fff;

  :hover {
    border-color: var(--orange);
  }
`
